import { useFormik } from "formik";
import { Grid, Button, Input, Typography } from "../../components";
import { SignInValidationSchema } from '@next-pontos/validations'
import { Fragment, useContext } from "react";
import AuthContext from "../../context/auth";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "@mui/material";

export function Login() {
    const { signIn } = useContext(AuthContext)
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const searchParamEmail = searchParams.get('email')

    const formik = useFormik({
        initialValues: {
            login: searchParamEmail || '',
            password: '',
        },
        onSubmit: async (values) => {
            const data = await signIn(values)

            if (data.lead_bid_id) {
                window.location.href = `/minhas-ofertas/nova?lead_bid_id=${data.lead_bid_id}`
                return
            }

            window.location.href = data.role && data.role !== 'USER' ? '/admin' : '/home'
        },
        validationSchema: SignInValidationSchema,
        validateOnMount: true
    })

    return (
        <Fragment>
            <div style={{ backgroundImage: 'url(/background.png)', height: '100vh', width: '100vw'}} className="flex flex-col bg-white bg-cover bg-center bg-no-repeat">
            <Grid container className="items-center justify-center flex-col h-full">
                <Grid item xs={12} sm={8} md={4}>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={1} className="p-2 gap-2 justify-center text-center">
                            <img src="/logo.png" alt="Logo" className="w-full max-w-[300px] h-auto" />
                            <Grid item xs={12}>
                                <Typography className="text-center">
                                    Next Gate Milhas - Consolidadora de Milhas com IATA
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className="text-center italic text-sm mt-[-8px]">
                                    Número IATA: 57602075
                                </Typography>
                            </Grid>
                            <Grid item xs={12} className="mt-1">
                                <Input
                                    label="Email ou CPF"
                                    name="login"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.login}
                                    helperText={formik.touched.login && formik.errors.login}
                                    error={!!formik.touched.login && !!formik.errors.login}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Input
                                    label="Senha"
                                    type="password"
                                    name="password"
                                    onChange={formik.handleChange}
                                    helperText={formik.touched.password && formik.errors.password}
                                    onBlur={formik.handleBlur}
                                    error={!!formik.touched.password && !!formik.errors.password}
                                />
                            </Grid>
                            <Grid item xs={12} className="mt-2">
                                <Button disabled={!formik.isValid} type="submit">Entrar</Button>
                            </Grid>
                            <Grid item xs={12} className="mt-2">
                                <Typography>
                                    Esqueceu sua senha? <Link href='/esqueci-minha-senha'>Clique aqui!</Link>
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography>
                                    Ainda não tem cadastro? <Link href={`/cadastro${searchParamEmail ? `?email=${searchParamEmail}` : ''}`}>Clique aqui!</Link>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} className="mt-10">
                                <Typography>
                                    Quer comprar milhas? <Link href={`https://api.whatsapp.com/send?phone=5511978644539&text=Quero%20comprar%20milhas%21`} target='_blank'>Clique aqui!</Link>
                                </Typography>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className="text-center">
                        <Grid item xs={12}>
                            <Typography className="text-center italic text-sm" variant="body2">
                                Número IATA: 57602075
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className="text-center italic text-sm" variant="body2">
                            CNPJ: 45.176.365/0001-00
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className="text-center italic text-sm" variant="body2">
                            Cadastur: 45.176.365/0001-00
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className="text-center italic text-sm" variant="body2">
                            Rua Treze de Maio, 1856 – CJ 52 – Bela Vista, São Paulo – 01327-002
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            </div>
        </Fragment>
    )
}